@for (row of gridRows; track row) {
  <div>
    @for (element of row.elements; track trackByIndex($index, element)) {
      <div
        #LMGridElement
        [attr.colIndex]="element.colIndex"
        [class]="element.class">
        <ng-template
          visiblewhen
          [layoutObject]="element?.layoutObject"
          [model]="model"
          [specFields]="specFields"
          >
          @if (element.field) {
            @if (!element.field.cfgHidden) {
              <lm-field
                [layoutObject]="element.field"
                [layoutInfo]="layoutInfo"
                [lmColumnLayoutInfo]="lmColumnLayoutInfo"
                [specFields]="specFields"
                [placeHolder]="placeHolder"
                [model]="model"
                (fieldEvent)="onFieldEvent($event)"
              ></lm-field>
            }
          }
          @if (element.checkcontrol) {
            @if (!element.checkcontrol.cfgHidden) {
              <lm-checkcontrol
                [layoutObject]="element.checkcontrol"
                [layoutInfo]="layoutInfo"
                [specFields]="specFields"
                [placeHolder]="placeHolder"
                [model]="model"
                (fieldEvent)="onFieldEvent($event)"
              ></lm-checkcontrol>
            }
          }
          @if (element.captchaControl) {
            <lm-captcha-control [layoutObject]="element.captchaControl"></lm-captcha-control>
          }
          @if (element.header) {
            <lm-header
              [layoutObject]="element.header"
              [layoutInfo]="layoutInfo"
              [specFields]="specFields"
              [model]="model"
              [previousSiblingIsCollapsible]="element.previousSiblingIsCollapsibleHeader"
              (fieldEvent)="onFieldEvent($event)"
            ></lm-header>
          }
          @if (element.paragraph) {
            <lm-paragraph
              [layoutObject]="element.paragraph"
              [layoutInfo]="layoutInfo"
              [lmColumnLayoutInfo]="lmColumnLayoutInfo"
              [specFields]="specFields"
              [placeHolder]="placeHolder"
              [model]="model"
              (fieldEvent)="onFieldEvent($event)"
            ></lm-paragraph>
          }
          @if (element.button) {
            @if (!element.button.cfgHidden) {
              <lm-button
                [layoutObject]="element.button"
                [layoutInfo]="layoutInfo"
                [lmColumnLayoutInfo]="lmColumnLayoutInfo"
                [specFields]="specFields"
                [model]="model"
                (fieldEvent)="onFieldEvent($event)"
              ></lm-button>
            }
          }
          @if (element.Blank) {
            @if (lmColumnLayoutInfo) {
              <div lm-blankline></div>
            }
            @if (!lmColumnLayoutInfo) {
              <div lm-blankline></div>
            }
          }
          @if (element.text) {
            <lm-text
              [layoutObject]="element.text"
              [layoutInfo]="layoutInfo"
              [lmColumnLayoutInfo]="lmColumnLayoutInfo"
              [specFields]="specFields"
              [placeHolder]="placeHolder"
              [model]="model"
              (fieldEvent)="onFieldEvent($event)"
            ></lm-text>
          }
          <!--      <ng-template [ngIf]="element.menu">-->
          <!--        <lm-simple-card-->
          <!--            [type]="'menu'"-->
          <!--            [specFields]="specFields"-->
          <!--            [model]="model"-->
          <!--            [scale]="element.menu.menuScale"-->
          <!--            [link]="element.menu.link"-->
          <!--            [showBackground]="false"-->
          <!--            [imageUrl] = "element.menu.image"-->
          <!--            [title]="element.menu.label"-->
          <!--            [description]="element.menu.description"-->
          <!--            [paragraphLayout]="false"-->
          <!--            [isLink]="element.menu.isLink"-->
          <!--            [isExternalLink]="element.menu.external"-->
          <!--            (fieldEvent)="onFieldEvent($event)"-->
        <!--        ></lm-simple-card>-->
      <!--      </ng-template>-->
    </ng-template>
  </div>
}
</div>
}

